export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/sellCarIcon.35d865ce.svg","height":30,"width":29,"blurWidth":0,"blurHeight":0};